import { Instagram, Linkedin, Facebook } from "lucide-react";
import { useLocation } from "react-router-dom";

const socials = [Instagram, Linkedin, Facebook];

export default function Footer() {
  const location = useLocation();
  const isCareerPage = location.pathname === "/careers";

  const quickLinks = [
    { label: "About", href: "#about" },
    { label: "Legacy", href: "#legacy" },
    { label: "Royale Raas", href: "#royale-raas" },
    { label: "Gallery", href: "#gallery" },
    {
      label: "Career With Us",
      href: location.pathname === "/" ? "#careers" : "/#careers",
    },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <footer
      data-testid="footer"
      className="border-t border-[var(--ee-border)] bg-[#060606]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center">
            {/* Increased brand logo size so it reads clearly in the footer alongside links. */}
            <img
              src="/logo/elite-eventz-logo.png"
              alt="Elite Eventz"
              className="h-16 w-auto select-none md:h-20"
              draggable={false}
            />
          </div>
          <p className="mt-5 text-sm text-neutral-400 max-w-xs leading-relaxed">
            Crafting Experiences. Creating Memories.
          </p>
        </div>

        {!isCareerPage && (
          <div>
            <p className="text-xs tracking-[0.28em] uppercase text-[var(--ee-gold)]">
              Quick Links
            </p>
            <ul className="mt-4 space-y-2">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-neutral-300 hover:text-[var(--ee-gold)] transition text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={isCareerPage ? "md:col-span-2" : ""}>
          <p className="text-xs tracking-[0.28em] uppercase text-[var(--ee-gold)]">
            Follow
          </p>
          <div className="mt-4 flex gap-3">
            {socials.map((Icon) => (
              <a
                key={Icon.displayName || Icon.name}
                href={
                  Icon === Instagram
                    ? "https://www.instagram.com/elite.eventz.official/?hl=en"
                    : Icon === Linkedin
                      ? "https://www.linkedin.com/company/eliteeventzpune/?viewAsMember=true"
                      : "https://www.facebook.com/profile.php?id=61592412537861&mibextid=wwXIfr"
                }
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${Icon.displayName || Icon.name}`}
                className="w-10 h-10 rounded-full border border-[var(--ee-border)] flex items-center justify-center text-neutral-300 hover:text-black hover:bg-[var(--ee-gold)] hover:border-[var(--ee-gold)] transition"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-[var(--ee-border)]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} Elite Eventz. All rights reserved.</p>
          <p>Designed &amp; developed with care.</p>
        </div>
      </div>
    </footer>
  );
}
